// src/services/api.ts
import axios from 'axios';
import { useAuthStore } from '../store/authStore';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:8000/api',
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
  withCredentials: true, // Include credentials for CORS requests
});

// Request interceptor - tambahkan token
api.interceptors.request.use((config) => {
  const token = useAuthStore.getState().token;
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  if (typeof window !== 'undefined') {
    config.headers['X-Frontend-Url'] = window.location.origin;
  }

  // Log untuk debugging
/*
  console.log(`[API] ${config.method?.toUpperCase()} ${config.baseURL}${config.url}`, {
    hasToken: !!token,
    headers: config.headers
  });
  */
  return config;
}, (error) => {
  console.error('[API] Request error:', error);
  return Promise.reject(error);
});

// Response interceptor - handle error
api.interceptors.response.use(
  (response) => {
    // console.log(`[API] Response 200:`, response.config.url, response.data);
    return response;
  },
  (error) => {
    // Log error details untuk debugging
    if (error.response) {
      console.error(`[API] Response error ${error.response.status}:`, error.response.config.url, error.response.data);
    } else if (error.request) {
      console.error('[API] No response received:', error.message, error.request);
    } else {
      console.error('[API] Request setup error:', error.message);
    }

    // Handle 401 - token expired
    if (error.response?.status === 401) {
      const currentPath = window.location.pathname;
      const publicPaths = ['/login', '/forgot-password', '/reset-password'];
      const isPublicPage = publicPaths.some(path => currentPath.startsWith(path));
      const isPublicApi = error.config?.url?.includes('/public/');

      if (!isPublicPage && !isPublicApi) {
        console.warn('[API] Unauthorized - clearing auth and redirecting to login');
        useAuthStore.getState().logout();
        window.location.href = '/login';
      } else {
        console.warn('[API] Unauthorized on public page/API - skipping redirect');
      }
    }
    return Promise.reject(error);
  }
);

export default api;
